<template>
	<div class="xinxi" v-if="showXinxi2">
		<div class="con">
			<p class="con_tit"><span></span><strong>重要信息变更</strong></p>
			<div class="con_con">
				<div class="form">
					<!--<h5>中国质量协会个人会员入会申请表</h5>-->
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm msg_box">
						<p class="tit_name">个人信息</p>
						<p style="text-align: left;margin-bottom: 24px;">
							<span style="margin-right: 33px;">会员类型</span>
							<el-form-item prop="member_type" style="display: inline-block;margin-bottom: 0;">
								<el-radio-group v-model="ruleForm.member_type">
									<el-radio label="普通会员 （480元/年）"></el-radio>
								</el-radio-group>
							</el-form-item>
						</p>

						<div class="default">
							<!--姓名-->
							<el-form-item class="type1" prop="name">
								<el-input v-model="ruleForm.name" placeholder="姓名" autocomplete="on"></el-input>
							</el-form-item>
							<span style="float: left;margin-left:20px;height: 100%;line-height: 40px;">先生/女士</span>
						</div>
						
						<el-form-item prop="id">
							<el-input v-model="ruleForm.id" placeholder="身份证号码"></el-input>
						</el-form-item>
						
						<p style="width: 250px;text-align: left;margin-bottom: 24px;">
							<el-form-item prop="choose_address" style="display: inline-block;margin-bottom: 0;">
								<el-radio-group v-model="ruleForm.choose_address">
									<el-radio label="单位地址"></el-radio>
									<el-radio label="家庭地址"></el-radio>
								</el-radio-group>
							</el-form-item>
						</p>

						<div class="default">
							<!--邮寄地址-->
							<el-form-item class="type1" prop="address">
								<el-input v-model="ruleForm.address" placeholder="邮寄地址" autocomplete="on"></el-input>
							</el-form-item>

							<!--邮政编码-->
							<el-form-item class="type2" prop="youbian">
								<el-input v-model="ruleForm.youbian" placeholder="邮政编码" autocomplete="on"></el-input>
							</el-form-item>
						</div>

						<div class="default">
							<!--所在行业-->
							<el-form-item class="type3" prop="kind">
								<el-select v-model="ruleForm.kind" placeholder="所在行业">
									<el-option label="制造业" value="制造业"></el-option>
									<el-option label="服务业" value="服务业"></el-option>
									<el-option label="医疗" value="医疗"></el-option>
									<el-option label="政府/组织" value="政府/组织"></el-option>
									<el-option label="教育" value="教育"></el-option>
								</el-select>
							</el-form-item>

							<!--其他行业-->
							<el-form-item class="type4" prop="other">
								<el-input v-model="ruleForm.other" placeholder="其他行业"></el-input>
							</el-form-item>
						</div>

						<p class="tit_name">单位信息</p>

						<!--单位名称-->
						<el-form-item prop="unit">
							<el-input v-model="ruleForm.unit" placeholder="单位名称"></el-input>
						</el-form-item>

						<div class="default">
							<!--部门-->
							<el-form-item class="type3" prop="department">
								<el-input v-model="ruleForm.department" placeholder="部门"></el-input>
							</el-form-item>

							<!--职务-->
							<el-form-item class="type3" prop="zhiwu">
								<el-input v-model="ruleForm.zhiwu" placeholder="职务"></el-input>
							</el-form-item>

							<!--个人电话-->
							<el-form-item class="type2" prop="phone">
								<el-input v-model="ruleForm.phone" placeholder="个人电话"></el-input>
							</el-form-item>
						</div>

						<div class="default">
							<!--手机-->
							<el-form-item class="type3" prop="mobile">
								<el-input v-model="ruleForm.mobile" placeholder="手机"></el-input>
							</el-form-item>

							<!--传真-->
							<el-form-item class="type3" prop="fax">
								<el-input v-model="ruleForm.fax" placeholder="传真"></el-input>
							</el-form-item>

							<!--邮箱-->
							<el-form-item class="type2" prop="mailbox">
								<el-input v-model="ruleForm.mailbox" placeholder="邮箱"></el-input>
							</el-form-item>
						</div>

						<p style="text-align:left;margin-bottom: 24px;">
							<span style="display: inline-block;margin-right: 15px;">最高学历</span>
							<el-form-item prop="choose_education" style="display: inline-block;margin-bottom: 0;">
								<el-radio-group v-model="ruleForm.choose_education">
									<el-radio label="高中"></el-radio>
									<el-radio label="专科"></el-radio>
									<el-radio label="本科"></el-radio>
									<el-radio label="硕士"></el-radio>
									<el-radio label="博士"></el-radio>
								</el-radio-group>
							</el-form-item>
						</p>

						<p class="tit_name">个人概况</p>

						<!--其他相关组织的情况-->
						<div class="default1">
							<div class="left">有关职称、职业资格注册或认证、以及加入中国质量协会之外其他相关组织的情况：</div>
							<el-form-item class="status" prop="msg">
								<el-input :rows="6" type="textarea" v-model="ruleForm.msg"></el-input>
							</el-form-item>
						</div>

						<!--需求及建议-->
						<div class="default2">
							<div class="left1">个人背景资料、研究成果或工作成绩以及获奖情况等</div>
							<el-form-item class="need" prop="achievement">
								<el-input type="textarea" :rows="3" v-model="ruleForm.achievement"></el-input>
							</el-form-item>
						</div>

						<p style="text-align: left;">请选择您最感兴趣的个人会员服务内容（可多选）</p>
						<div class="default">
							<el-form-item prop="pro" style="margin-bottom: 0;">
								<el-checkbox-group v-model="ruleForm.pro">
									<el-checkbox label="质量资讯" name="pro"></el-checkbox>
									<el-checkbox label="质量文章/论文" name="pro"></el-checkbox>
									<el-checkbox label="质量论坛" name="pro"></el-checkbox>
									<el-checkbox label="质量数据库" name="pro"></el-checkbox>
									<el-checkbox label="经验交流" name="pro"></el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</div>

						<p style="text-align: left;">请选择您最认可的会员服务方式（可多选）</p>

						<div class="default2" style="border: none;height: 90px;">
							<el-form-item prop="way" style="margin-bottom: 0;">
							    <el-checkbox-group v-model="ruleForm.way">
							      <el-checkbox label="电子会刊" name="way"></el-checkbox>
							      <el-checkbox label="传统出版物" name="way"></el-checkbox>
							      <el-checkbox label="会员俱乐部活动" name="way"></el-checkbox>
							      <el-checkbox label="会议" name="way"></el-checkbox>
							      <el-checkbox label="培训" name="way"></el-checkbox>
							      <el-checkbox label="网络论坛" name="way"></el-checkbox>							      
							    </el-checkbox-group>
							 </el-form-item>
						</div>

						<!--<p style="text-align: left;margin-bottom: 15px;">会员定期读物接收信息（请准确填写，以免影响会员服务）</p>
						<div class="default">
							收件人姓名
							<el-form-item class="type1" prop="s_name">
								<el-input v-model="ruleForm.s_name" placeholder="收件人姓名"></el-input>
							</el-form-item>

							收件人电话
							<el-form-item class="type2" prop="s_phone">
								<el-input v-model="ruleForm.s_phone" placeholder="收件人电话"></el-input>
							</el-form-item>

						</div>

						<div class="default">
							<el-select v-model="prov" class="type3">
								<el-option v-for="(option,index) in arr" :key="index" :value="option.name">
									{{ option.name }}
								</el-option>
							</el-select>
							<el-select v-model="city" class="type3">
								<el-option v-for="(option,index) in cityArr" :key="index" :value="option.name">
									{{ option.name }}
								</el-option>
							</el-select>
							<el-select v-model="district" v-if="district" class="type2">
								<el-option v-for="(option,index) in districtArr" :key="index" :value="option.name">
									{{ option.name }}
								</el-option>
							</el-select>
						</div>

						<el-form-item prop="xaddress">
							<el-input v-model="ruleForm.xaddress" placeholder="完整地址"></el-input>
						</el-form-item>-->

						<el-form-item class="btn_box">
							<el-button class="btn" type="primary" @click="submitForm1('ruleForm')">提交</el-button>
						</el-form-item>
					</el-form>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import { Loading } from 'element-ui'
	import area from '../../static/js/area.js'
	import Qs from 'qs'
	let flag = true
	export default {
		data() {
			return {
				file: '',
				filename: '',
				list: false,
				temp: [],
				name: 'Cselect',
				arr: area.arrAll,
				prov: '省份',
				city: '城市',
				district: '区域',
				cityArr: [],
				districtArr: [],
				ruleForm: {
					member_type: '普通会员 （480元/年）',
					name: '',
					choose_address: '',
					address: '',
					youbian: '',
					kind: '',
					other: '',
					unit: '',
					department: '',
					zhiwu: '',
					phone: '',
					mobile: '',
					fax: '',
					mailbox: '',
					choose_education: '',
					msg: '',
					achievement: '',
					pro: [],
					way: [],
					s_name: '',
					s_phone: '',
					xaddress: '',
					id: '',
				},
				rules: {
					member_type: [{
						required: true,
						message: '请选择会员类型',
						trigger: 'change'
					}],
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}, ],
					choose_address: [{
						required: true,
						message: '请选择一个地址',
						trigger: 'change'
					}],
					address: [{
						required: true,
						message: '请输入邮寄地址',
						trigger: 'blur'
					}, ],
					youbian: [{
						required: true,
						message: '请输入邮政编码',
						trigger: 'blur'
					}, 
					{ pattern: /^[0-9]{6}$/, message: '输入正确的邮编' }
					],
					//			        kind: [
					//			            { required: true, message: '请选择所在行业', trigger: 'change' }
					//			        ],
					//			        other: [
					//			            { required: true, message: '请输入其他行业', trigger: 'blur' },
					//			        ],			        
					unit: [{
						required: true,
						message: '请输入单位名称',
						trigger: 'blur'
					}, ],
					department: [{
						required: true,
						message: '请输入部门',
						trigger: 'blur'
					}, ],
					zhiwu: [{
						required: true,
						message: '请输入职务',
						trigger: 'blur'
					}, ],
					phone: [{
						required: true,
						message: '请输入个人电话',
						trigger: 'blur'
					}, ],
					mobile: [{
						required: true,
						message: '请输入手机',
						trigger: 'blur'
					}, 
					{ pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/, message: '输入11位手机号' }
					],
					fax: [{
						required: true,
						message: '请输入传真',
						trigger: 'blur'
					}, ],
					mailbox: [{
						required: true,
						message: '请输入邮箱',
						trigger: 'blur'
					}, 
					{ pattern:  /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, message: '输入正确的邮箱' }
					],
					choose_education: [{
						required: true,
						message: '请选择最高学历',
						trigger: 'change'
					}],
					msg: [{
						required: true,
						message: '请输入职称、职业资格注册或认证、及其他相关组织的情况',
						trigger: 'blur'
					}],
					achievement: [{
						required: true,
						message: '请输入个人背景资料、研究成果或工作成绩以及获奖情况',
						trigger: 'blur'
					}],
					pro: [{
						type: 'array',
						required: true,
						message: '请至少选择一个最感兴趣的个人会员服务内容',
						trigger: 'change'
					}],
					way: [{
						type: 'array',
						required: true,
						message: '请至少选择一个您最认可的会员服务方式',
						trigger: 'change'
					}],
//					s_name: [{
//						required: true,
//						message: '请输入收件人姓名',
//						trigger: 'blur'
//					}],
//					s_phone: [{
//						required: true,
//						message: '请输入收件人电话',
//						trigger: 'blur'
//					}],
//					xaddress: [{
//						required: true,
//						message: '请输入完整地址',
//						trigger: 'blur'
//					}],
					id: [{
						required: true,
						message: '请输入身份证号码',
						trigger: 'blur'
					},
					{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '输入正确的身份证号码' }
					],
				}

			};
		},
		props: {
			showXinxi2: {
				type: Boolean
			}
		},
		created() {
		},
		mounted() {
			if(sessionStorage.getItem('Token')) {
				var token = sessionStorage.getItem('Token');
			};
			var data1={
				'access-token':token
			};
			this.$axios({
				method: 'post',
				url: 'personal/applicationform',
				data: Qs.stringify(data1)
			}).then(response => {
				if(response.data.state == 2) {
					if(response.data.data.length != 0) {
						this.ruleForm.name = response.data.data.name;
						this.ruleForm.choose_address = response.data.data.address_type;
						this.ruleForm.address = response.data.data.address;
						this.ruleForm.youbian = response.data.data.zipcode;
						this.ruleForm.unit = response.data.data.company_name;
						this.ruleForm.department = response.data.data.department;
						this.ruleForm.zhiwu = response.data.data.post;
						this.ruleForm.phone = response.data.data.phone;
						this.ruleForm.mobile = response.data.data.mobile;
						this.ruleForm.fax = response.data.data.fax;
						this.ruleForm.mailbox = response.data.data.email;
						this.ruleForm.choose_education = response.data.data.education;
						this.ruleForm.msg = response.data.data.personal_certificate;
						this.ruleForm.achievement = response.data.data.personal_data;
//						this.ruleForm.s_name = response.data.data.contact;
//						this.ruleForm.s_phone = response.data.data.contact_phone;
//						this.prov = response.data.data.province;
//						this.city = response.data.data.city;
//						this.district = response.data.data.district;
//						this.ruleForm.xaddress = response.data.data.detailed_address;
						this.ruleForm.id = response.data.data.id_number;
						
						this.ruleForm.pro = response.data.data.interest.split(',');
			        	this.ruleForm.way = response.data.data.accept.split(',');
						var arr = ['制造业','服务业','医疗','政府/组织','教育'];
			        	if(arr.indexOf(response.data.data.professions) >=0){
			        		this.ruleForm.kind = response.data.data.professions;
			        	}else{
			        		this.ruleForm.other = response.data.data.professions;
			        	}
					}
				}
			});
		},
		methods: {
			updateCity: function() {
				for(var i in this.arr) {
					var obj = this.arr[i];
					if(obj.name) {
						if(obj.name == this.prov) {
							this.cityArr = obj.sub;
							break;
						}
					}
				}
				this.city = this.cityArr[1].name;
			},
			updateDistrict: function() {
				for(var i in this.cityArr) {
					var obj = this.cityArr[i];
					if(obj.name == this.city) {
						this.districtArr = obj.sub;
						break;
					}
				}
				if(this.districtArr && this.districtArr.length > 0 && this.districtArr[1].name) {
					this.district = this.districtArr[1].name;
				} else {
					this.district = '';
				}
			},
			submitForm1(formName) {
				this.$refs[formName].validate((valid) => {
					if(valid) {
						if(!this.ruleForm.kind && !this.ruleForm.other) {
							this.$toast('请选择或填写所在行业')
							return false;
						};
//						if(this.prov == '省份') {
//							this.$toast('请选择省份');
//							return false;
//						};
//						if(this.city == '城市') {
//							this.$toast('请选择城市');
//							return false;
//						};
//						if(this.district == '区域') {
//							this.$toast('请选择区域');
//							return false;
//						};
						Loading.service();
						if(sessionStorage.getItem('Token')) {
							var token = sessionStorage.getItem('Token');
						};
						let data = {
							'access-token':token,
							'name': this.ruleForm.name,
							'address_type': this.ruleForm.choose_address,
							'address': this.ruleForm.address,
							'zipcode': this.ruleForm.youbian,
							'professions': this.ruleForm.kind ? this.ruleForm.kind : this.ruleForm.other,
							'company_name': this.ruleForm.unit,
							'department': this.ruleForm.department,
							'post': this.ruleForm.zhiwu,
							'phone': this.ruleForm.phone,
							'mobile': this.ruleForm.mobile,
							'fax': this.ruleForm.fax,
							'email': this.ruleForm.mailbox,
							'education': this.ruleForm.choose_education,
							'personal_certificate': this.ruleForm.msg,
							'personal_data': this.ruleForm.achievement,
							'interest': this.ruleForm.pro.join(','),
							'accept': this.ruleForm.way.join(','),
//							'contact': this.ruleForm.s_name,
//							'contact_phone': this.ruleForm.s_phone,
//							'province': this.prov,
//							'city': this.city,
//							'district': this.district,
//							'detailed_address': this.ruleForm.xaddress,
							'id_number': this.ruleForm.id,
						};
						if(flag){
							flag = false;
							this.$axios({
								method: 'post',
								url: 'personal/modifypersonalinfo',
								data: Qs.stringify(data)
							}).then(response => {
								let loadingInstance = Loading.service();
								loadingInstance.close();
								flag = true;
								this.$toast(response.data.msg);
							});
						}
					} else {
						this.$toast('请完善资料后再提交');
					}
				})

			},
		}
	}
</script>
<style scoped>
	.clearfix::after {
		content: ".";
		clear: both;
		visibility: hidden;
		height: 0;
		display: block;
		line-height: 0;
	}
	
	.clearfix {
		zoom: 1;
	}
	
	.fl {
		float: left;
	}
	
	.fr {
		float: right;
	}
	
	.rap {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.xinxi {
		width: 100%;
		height: auto;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #404040;
		text-align: left;
	}
	
	.con {
		width: 100%;
		height: auto;
		position: relative;
	}
	
	.con_tit {
		padding-left: 18px;
		box-sizing: border-box;
		color: #005EB3;
		font-size: 18px;
		line-height: 45px;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.con_tit span{
		width:4px;
		height:16px;
		background:#4799E4;
		margin-right: 7px;
	}
	
	.con_con {
		padding:0 37px 0 41px;
		width: 100%;
		height: auto;
		/*background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(207, 212, 214, 1);*/
		box-sizing: border-box;
	}
	
	.con_con_tit {
		font-size: 16px;
		font-weight: bold;
		line-height: 35px;
		border-bottom: 1px solid #CFD4D6;
		margin-bottom: 6px;
	}
	
	.form {
		margin: 20px auto 32px;
		width: 819px;
		height: auto;
		border: 1px solid rgba(231, 231, 231, 1);
	}
	
	.form h5 {
		height: 60px;
		border-bottom: 1px solid #E7E7E7;
		line-height: 60px;
		color: #404040;
		font-size: 20px;
		font-weight: bold;
	}
	
	.msg_box {
		position: relative;
		width: 590px;
		height: auto;
		margin: 22px auto 0;
		overflow: hidden;
	}
	
	.tit_name {
		text-align: left;
		font-size: 18px;
		color: #4F4F4F;
		line-height: 45px;
		font-weight: bold;
	}
	
	.default {
		width: 100%;
		height: 40px;
		margin-bottom: 21px;
	}
	
	.type1 {
		float: left;
		width: 362px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
	}
	
	.type2 {
		float: right;
		width: 208px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
	}
	
	.type3 {
		float: left;
		width: 174px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		margin-right: 13px;
	}
	
	.type4 {
		float: right;
		width: 403px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
	}
	
	.type5 {
		float: left;
		width: 140px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		margin-right: 10px;
	}
	
	.type6 {
		float: left;
		width: 287px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		margin-right: 15px;
	}
	
	.type7 {
		float: left;
		width: 108px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		margin-right: 11px;
	}
	
	.fr {
		float: right;
		margin-right: 0;
	}
	
	.default1 {
		width: 100%;
		height: 140px;
		margin-bottom: 22px;
		border: 1px solid #E7E7E7;
		box-sizing: border-box;
	}
	
	.left {
		width: 134px;
		height: 116px;
		background: rgba(250, 250, 250, 1);
		border-radius: 3px 0px 0px 3px;
		border: 1px solid #E7E7E7;
		float: left;
		padding-top: 20px;
		text-align: center;
		color: #808080;
	}
	
	.status {
		width: 452px;
		float: right;
	}
	
	.default2 {
		width: 100%;
		height: 77px;
		margin-bottom: 22px;
		border: 1px solid #E7E7E7;
		box-sizing: border-box;
	}
	
	.left1 {
		width: 134px;
		height: 63px;
		background: rgba(250, 250, 250, 1);
		border-radius: 3px 0px 0px 3px;
		border: 1px solid #E7E7E7;
		float: left;
		padding-top: 10px;
		text-align: center;
		color: #808080;
	}
	
	.need {
		width: 452px;
		float: right;
	}
	
	.btn {
		display: block;
		border: none;
		margin: 0 auto;
		width: 160px;
		height: 48px;
		background: rgba(6, 98, 181, 1);
		border-radius: 4px;
		color: #fff;
	}
	
	.add {
		position: relative;
		cursor: pointer;
		font-size: 14px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.65);
		line-height: 32px;
		width: 106px;
		height: 32px;
		background: rgba(255, 255, 255, 1) url(../../static/img/input.png) no-repeat;
		background-size: 100%;
	}
	
	.file {
		position: absolute;
		left: -9999px;
	}
	
	.note {
		color: #CFD4D6;
		text-indent: 100px;
	}
	
	.btn {
		width: 160px;
		height: 48px;
		background: rgba(0, 118, 255, 1);
		border-radius: 4px;
		color: #fff;
		border: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/Xinxi1.vue